<template>
  <div class="modal fade" :class="{'is-open': open}">
    <div class="modal-dialog" style="width: 926px;">
      <div class="modal-content">
        <div class="modal-header">
          <a class="close" @click="close()">
            <i class="icon-close"></i>
          </a>
          <h3 :key="`Non-Visit-h3-${record.id}`" class="modal-title">要保人{{record.name| getMaskName}}未拜訪回報</h3>
        </div>
        <div class="modal-body send-modal-body" style="min-height:220px;" :class="{ 'section-loading': isLoading }">
          <div class="form-group mt-3">
            <div class="radio radio-inline">
              <input type="radio" v-model="req.picked" id="radio-Non-2" value="1" />
              <label for="radio-Non-2">保戶旅居海外</label>
            </div>
            <br />
            <div class="radio radio-inline">
              <input type="radio" v-model="req.picked" id="radio-Non-3" value="2" />
              <label for="radio-Non-3">無法遇人</label>
            </div>
            <br />
            <div class="radio radio-inline">
              <input type="radio" v-model="req.picked" id="radio-Non-4" value="3" />
              <label for="radio-Non-4">保戶拒訪</label>
            </div>
            <br />
            <div class="radio radio-inline">
              <input type="radio" v-model="req.picked" id="radio-Non-5" value="4" />
              <label for="radio-Non-5">保戶身故</label>
            </div>
            <br />
            <div class="radio radio-inline">
              <input type="radio" v-model="req.picked" id="radio-Non-7" value="5" />
              <label for="radio-Non-7">其他</label>
            </div>
            <div>
              <input
                v-if="req.picked == 5"
                type="text"
                id="Nonreason"
                name="Nonreason"
                maxlength="50"
                placeholder="文字內容"
                class="form-control"
                v-model="req.reason"
              />
              <input
                v-else
                type="text"
                id="Nonreason"
                name="Nonreason"
                maxlength="50"
                placeholder="文字內容"
                class="form-control"
                v-model="req.reason"
                :disabled="true"
              />
            </div>
            <br />
          </div>
          <div class="action text-right">
            <a @click.stop.prevent="previous()" class="btn btn-primary">上一步</a>
            <a @click.stop.prevent="submit()" class="btn btn-primary">提交</a>
          </div>
        </div>
      </div>
    </div>

    <!-- 提醒資訊-->
    <warning-modal
      :message="message"
      :open="warningModalOpen"
      :confirmText="'確定送出'"
      :cancelText="'上一步'"
      @submit="ClosewarningModal()"
      @close="panelClose('warningModalOpen')"
    />
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { commonMixin } from "@/mixins/common";
import { updateUnVisit } from "@/service";
import WarningModal from "@/desktop/components/WarningModal";

export default {
  name: "NonVisitModal",
  mixins: [commonMixin],
  components: { WarningModal },
  props: {
    record: {
      // 客戶list 資料
      type: Object,
      default: () => {
        return null;
      }
    },
    open: {
      type: Boolean,
      default: false
    },
    catInfo: {
      // 專區資訊
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      warningModalOpen: false,
      message: "",
      nameBir: "",
      req: {
        reason: "",
        picked: ""
      },
      edit: false,
      type: String,
      isLoading: false,

    };
  },
  watch: {
    open(val) {
      if (val) {
        this.Init();
      }
    }
  },
  methods: {
    ...mapActions(["setPageLock"]),
    Init() {
      // 初始化
      this.req.reason = this.record.unvisit_memo;
      this.req.picked = this.record.unvisit_reply;
      this.registerHanlink(); // for 難字更新
    },
    submit() {
      if (!this.req.picked) {
        this.setToastMsg("尚有回報項目未點選，請再確認後再「提交」");
      } else if ((this.req.picked == 5) & !this.req.reason) {
        this.setToastMsg("選其他時務必輸入備註內容或原因，以避免後續糾紛");
      } else {
        this.message =
          "<span style=color:red;>請確認本次回報已確實填寫再點選送出！</span><br/>";
        this.panelOpen("warningModalOpen");
      }
    },
    ClosewarningModal() {
      this.panelClose("warningModalOpen");
      let reportData = {
        picked: this.req.picked,
        reasonmemo: this.req.reason,
        customer_id: this.record.id
      };
      this.isLoading = true; //開啟遮罩
      updateUnVisit(
        this.$store.state.userInfo.id,
        this.$store.state.userInfo.divNo,
        reportData
      ).then(result => {
        this.isLoading = false; //關閉遮罩
        if (result.header && result.header.status == "200") {
          this.close();
        } else {
          this.close();
        }
      });
    },
    close() {
      this.$emit("close");
    },
    previous() {
      this.req.reason = "";
      this.req.picked = "";
      this.$emit("previous");
    }
  },
  mounted() {}
};
</script>

<style>
.vdp-datepicker input {
  width: 100px;
  padding: 10px;
}
.select-100 {
  width: 170px;
}
.non-select-arrow {
  -webkit-appearance: none;
  -moz-appearance: none;
  text-indent: 1px;
  text-overflow: "";
}
.btn-grids .btn {
  position: relative;
  padding: 8px;
  width: 24%;
  font-size: 1rem;
  margin: 0px;
  margin-bottom: 10px;
  margin-right: 1%;
}
.btn-grids .add-new {
  padding: 8px;
  width: 50px !important;
  font-size: 16px;
}
.btn-grids .btn .close {
  position: absolute;
  right: -10px;
  top: -10px;
}
</style>